import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { modelProfilesQueryKey } from "@/shared/domain/agentThread/hooks/useModelProfiles";

import type {
  OrgModelListResponse,
  VerifyOrgModelResponse,
} from "../OrgLlmProviderRecord";

import { orgQueryKeys } from "./orgQueryKeys";

/**
 * Call one of the org's own-connection models and record the outcome on it
 * (premium orgs, admins). The returned list replaces the cached one, and chat
 * model profiles are refetched since the model may have become usable or
 * unusable. A failed call resolves with `error` set.
 */
export function useVerifyOrgLlmModel() {
  const { orgService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    VerifyOrgModelResponse,
    Error,
    { orgId: string; profileId: string }
  >({
    mutationFn: ({ orgId, profileId }) =>
      orgService.verifyOrgLlmModel(orgId, profileId),
    onSuccess: ({ config, connections }, { orgId }) => {
      queryClient.setQueryData<OrgModelListResponse>(
        orgQueryKeys.llmProvider(orgId),
        { config, connections },
      );
      void queryClient.invalidateQueries({
        queryKey: modelProfilesQueryKey(orgId),
      });
    },
  });
}
